import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    Title,
} from 'chart.js';

import { Doughnut } from 'react-chartjs-2';

ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    Title
);

export default function DoughnutChart(props) {
    const chartOptions = {
        ...props.options,
        responsive: true,
        maintainAspectRatio: false,
    };
    return (
        <div style={{
            // padding: '15px',
            marginTop: "10px",
            minHeight: "200px"
        }}>
            <Doughnut data={props.data} options={props.options} />
        </div>
    );
}